import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  getAxiosResponse,
  postAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useNavigate } from "react-router-dom";
import Constants from "../../../Constants";
import { dateFormat, dateFormatAndStatus } from "../../../services/Util";
import DataTable from "react-data-table-component";
import $ from "jquery";
import { useForm } from "react-hook-form";
import SuccessMessage from "../../../components/SuccessMessage";
import { useSelector } from "react-redux";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { editPOSchema } from "../../../ValidationSchema";
import { ActivatedClip, DeActivateClip, EditIcon } from "../../../AppIcons";

export default function PurchaseOrder() {
  const scrollRef = useRef(null);
  const editRef = useRef();
  const paginationRef = useRef();
  const inPaginationRef = useRef();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const translate = t;
  const [mandatory, setMandatory] = useState(null);
  const [isForced, setForced] = useState(null);
  const [activePOList, setActivePOList] = useState([]);
  const [inActivePOList, setInActivePOList] = useState([]);
  const [totalActiveRows, setTotalActiveRows] = useState(0);
  const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [refresh, setRefresh] = useState(null);
  const [poName, setPOName] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [poDesc, setPODesc] = useState("");
  const [valueTotal, setValueTotal] = useState("");
  const [purchaseOrder, setPurchaseOrder] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [pending, setPending] = useState(false);
  const [pendingInactive, setPendingInactive] = useState(false);
  const [sortKey, setSortKey] = useState("customerPurchaseOrder.poNumber");
  const activeSortOrder = useRef(1);
  const inActiveSortOrder = useRef(1);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [page2, setPage2] = useState(1);
  const [perPage2, setPerPage2] = useState(10);
  const [isEdit, setEdit] = useState(false);
  const [savedData, setSavedData] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [currencySymbol, setSymbol] = useState("$");

  const [editPoName, setEditname] = useState("");
  const [editPoNumber, setEditPoNumber] = useState("");
  const [editPoDesc, setEditPoDesc] = useState("");
  const [editPoValue, setEditPoValue] = useState("");
  const [editPoCurrency, setEditPoCurrency] = useState("");
  const [paginationSelect, setPaginationSelect] = useState(false);
  const [paginationSelectInactive, setPaginationSelectInactive] = useState(false);
  const [errors2,setErrors2] = useState({});

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onChange" });
  
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;


  useEffect(() => {
    if (successMessage !== Constants.BLANK) {
      setTimeout(function () {
        setSuccessMessage(Constants.BLANK);
      }, 5000);
    } else if (successMessage === Constants.BLANK) {
      setTimeout(function () {
        $('.lastdisable').trigger('focus');
      }, 300);
    }
  }, [successMessage]);

  useEffect(() => {
    fetchMandatoryData();
    fetchActivePOList();
    fetchInactivePOList();
    fetchCurrencies();
    $(document).ready(function(){
      $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
      $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
     })
  }, []);

  useEffect(() => {}, [isForced, purchaseOrder]);

  useEffect(() => {
    handlePageChange(page);
  }, [perPage, page,refresh]);

  useEffect(() => {
    handlePageChangeInActive(page2);
  }, [perPage2, page2,refresh]);

  useEffect(() => {
    if (poName !== "" && poNumber !== "" && valueTotal !== "" && selectedCurrency !== "") {
      enableAddButton();
    } else {
      const addButton = $("#add-button");
      if (!addButton.hasClass("disabled-data")) {
        addButton.addClass("disabled-data");
      }
    }
  }, [poName, poNumber, valueTotal, selectedCurrency]);

  // const checkKeyDown = (event) => {
  //   if (event.key === Constants.ENTER) {
  //     event.preventDefault();
  //   }
  // };

  const fetchCurrencies = () => {
    getAxiosResponse(APIUrls.ALL_AVAILABLE_CURRENCIES)
      .then((response) => {
        setCurrencies(response.data.data);
        response.data.data?.forEach((currency) => {
          if (currency.defaultValue === true) {
            setSelectedCurrency(currency.code);
            setSymbol(currency.symbol);
          }
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const activateDeactivatePO = (po, activate) => {
    let data = {
      id: po.id,
      poNumber: po.poNumber,
      poName: po.poName,
      poDesc: po.poDesc,
      valueTotal: {
        value: po.valueTotal.value,
      },
      enabled: activate,
      valueCurrent: {
        value: po.valueCurrent.value,
      },
      spentClosed: {
        value: po.spentClosed.value,
      },
      spentTranslation: {
        value: po.spentTranslation.value,
      },
      currency: po.currency,
    };
    putAxiosResponse(APIUrls.PO_UPDATE(data.id), data)
      .then((response) => {
        if (response?.data?.code === 200) {
          if (activate) {
            setSuccessMessage("Purchase Order Activated.");
          } else {
            setSuccessMessage("Purchase Order Deactivated.");
          }
          setRefresh(refresh ? false : true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const toggleCheckBox = (isChecked) => {
    setForced(isChecked);
    if (isChecked !== savedData) {
      $("#yes-no-save").removeClass("disabled-data");
    } else {
      $("#yes-no-save").addClass("disabled-data");
    }
  };

  const makeMandatory = () => {
    let data = {
      poForcedByAdmin: false,
      poForcedByUser: isForced,
    };
    postAxiosResponse(APIUrls.PO_MANDATORY, data)
      .then((response) => {
        if (response.data.code === 200) {
          $("#yes-no-save").addClass("disabled-data");
          setSuccessMessage("Setting saved!");
          setRefresh(refresh ? false : true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const button = $("#yes-no-save");
    if (isForced === savedData) {
      button.addClass("disabled-data");
    } else {
      button.removeClass("disabled-data");
    }
  }, [isForced, savedData]);

  useEffect(() => {
    $(document).ready(function () {
      if ($("[data-sort-id=action]").length > 0) {
        $("[data-sort-id=action]").attr("tabIndex", -1);
      }
      if ($("[data-sort-id=actionin]").length > 0) {
        $("[data-sort-id=actionin]").attr("tabIndex", -1);
      }
    });
  }, []);

  const fetchMandatoryData = () => {
    getAxiosResponse(APIUrls.PO_MANDATORY)
      .then((response) => {
        if (response?.data?.code === 200) {
          const mandatory = response?.data?.data;
          setMandatory(mandatory);
          setSavedData(mandatory.poForcedByAdmin || mandatory.poForcedByUser);
          setForced(mandatory.poForcedByAdmin || mandatory.poForcedByUser);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const addPO = (values) => {
    const data = {
      poNumber: values.poNumber,
      poName: values.poName,
      poDesc: values.poDesc,
      valueTotal: {
        value: values.valueTotal,
      },
      enabled: true,
      valueCurrent: {
        value: values.valueTotal,
      },
      spentClosed: {
        value: 0,
      },
      spentTranslation: {
        value: 0,
      },
      currency: selectedCurrency,
    };

    postAxiosResponse(APIUrls.PO_CREATE_NEW, data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setRefresh(refresh ? false : true);
          resetAddPO();
          const addButton = $("#add-button");
          if (!addButton.hasClass("disabled-data")) {
            addButton.addClass("disabled-data");
          }
          setSuccessMessage("Purchase Order Created!");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const enableAddButton = () => {
    const addButton = $("#add-button");
    if (addButton.hasClass("disabled-data")) {
      addButton.removeClass("disabled-data");
    }
  };

  const resetAddPO = () => {
    setPOName("");
    setPoNumber("");
    setPODesc("");
    setValueTotal("");
    setSelectedCurrency(currencies[0]);
  };

  const reset = () => {
    setEditPoCurrency("");
    setEditPoNumber("");
    setEditPoDesc("");
    setEditPoValue("");
    setEditname("");
    setErrors2({});
    //setSelectedCurrency(currencies[0]);
  };

  const handleCurrencyChange = (e) => {
    setSelectedCurrency(e.code);
    setSymbol(e.symbol);
  };

  const handleChange = (newPerPage, page) => {
    setPaginationSelect(true);
    setPerPage(newPerPage);
    setPage(page);
  };

  const handleChangeInactive = (newPerPage, page) => {
    setPaginationSelectInactive(true);
    setPerPage2(newPerPage);
    setPage2(page);
  };

  const handlePageChange = (paging) => {
    if ($('.active-purchase-order #pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('.active-purchase-order #pagination-previous-page').attr('id');
    } else if ($('.active-purchase-order #pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('.active-purchase-order #pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
    setPending(true);
    getAxiosResponse(
      APIUrls.PO_SORTED_LIST_BY_FIELD(1, sortKey, activeSortOrder.current, paging, perPage)
    )
      .then((response) => {
        if (response?.data?.code === 200) {
          setActivePOList(response?.data?.data?.result);
          setTotalActiveRows(response?.data?.data?.resultCount);
        }
        setPending(false);
        setTimeout(function(){
          if (paginationSelect) {
            $('.active-purchase-order nav.rdt_Pagination select').trigger('focus');
            setPaginationSelect(false);
          }
          if (paginationRef.current) {
            $('.active-purchase-order #'+ paginationRef.current).trigger('focus');
            paginationRef.current = '';
          }
        }, 100);
      })
      .catch((err) => {
        console.error(err);
        setPending(false);
      });
  };

  const customSort = (column, direction) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
        .attr({ 'aria-label': column.name, 'aria-sort': direction.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
    let sortOrder = direction === "asc" ? 0 : 1;
    let sortKey = `customerPurchaseOrder.${column.sortField}`;
    setSortKey(sortKey);
    activeSortOrder.current = sortOrder;
    getAxiosResponse(
      APIUrls.PO_SORTED_LIST_BY_FIELD(1, sortKey, sortOrder, 1, perPage)
    )
      .then((response) => {
        if (response?.data?.code === 200) {
          setActivePOList(response?.data?.data?.result);
          setTotalActiveRows(response?.data?.data?.resultCount);
        }
        setPending(false);
      })
      .catch((err) => {
        console.error(err);
        setPending(false);
      });
  };

  const customSortInActive = (column, direction) => {
    let sortOrder = direction === "asc" ? 0 : 1;
    let sortKey = `customerPurchaseOrder.${column.sortField}`;
    setSortKey(sortKey);
    inActiveSortOrder.current = sortOrder;    
    getAxiosResponse(
      APIUrls.PO_SORTED_LIST_BY_FIELD(0, sortKey, sortOrder, 1, perPage)
    )
      .then((response) => {
        if (response?.data?.code === 200) {
          setInActivePOList(response?.data?.data?.result);
          setTotalInActiveRows(response?.data?.data?.resultCount);
        }
        setPendingInactive(false);
      })
      .catch((err) => {
        console.error(err);
        setPendingInactive(false);
      });
  };

  const handlePageChangeInActive = (paging) => {
    if ($('.inactive-purchase-order #pagination-last-page').attr('aria-disabled')==="true") {
      inPaginationRef.current = $('.inactive-purchase-order #pagination-previous-page').attr('id');
    } else if ($('.inactive-purchase-order #pagination-first-page').attr('aria-disabled')==="true") {
      inPaginationRef.current = $('.inactive-purchase-order #pagination-next-page').attr('id');
    } else {
      inPaginationRef.current = document.activeElement.id;
    }
    setPendingInactive(true);
    getAxiosResponse(APIUrls.PO_SORTED_LIST_BY_FIELD(0,sortKey,inActiveSortOrder.current,paging,perPage2))
      .then((response) => {
        if (response?.data?.code === 200) {
          setInActivePOList(response?.data?.data?.result);
          setTotalInActiveRows(response?.data?.data?.resultCount);
        }
        setPendingInactive(false);        
        setTimeout(function(){
          if (paginationSelectInactive) {
            $('.inactive-purchase-order nav.rdt_Pagination select').trigger('focus');
            setPaginationSelectInactive(false);
          }
            if (inPaginationRef.current) {
              $('.inactive-purchase-order #'+ inPaginationRef.current).trigger('focus');
              inPaginationRef.current = '';
            }
        }, 100);
      })
      .catch((err) => {
        console.error(err);
        setPendingInactive(false);
      });
  };

  const activeListColumns = [
    {
      id: "poNumber",
      name: "PO Number",
      selector: (row) => row.poNumber,
      sortable: true,
      sortField: "poNumber",
      cell: (row) => (
        <a tabIndex="0" onClick={() => {}}>
          {row.poNumber}
        </a>
      ),
    },
    {
      id: "poName",
      name: "Name",
      selector: (row) => row.poName,
      sortable: true,
      sortField: "poName",
    },
    {
      id: "currency",
      name: "Currency",
      sortable: true,
      selector: (row) => row.currency,
      sortField: "currency",
    },
    {
      id: "povalue",
      name: "PO Value",
      selector: (row) => row.valueTotal?.display,
      sortable: true,
      sortField: "valueTotal",
    },
    {
      id: "spentvalue",
      name: "Spent in Closed Projects",
      minWidth: "250px",
      selector: (row) => row.spentClosed?.display,
      sortable: true,
      sortField: "spentClosed",
    },
    {
      id: "commitedvalue",
      name: "Committed to Open Projects",
      minWidth: "250px",
      selector: (row) => row.spentTranslation?.display,
      sortable: true,
      sortField: "spentTranslation",
    },
    {
      id: "balance",
      name: "Balance",
      selector: (row) => row.valueCurrent?.display,
      sortable: true,
      sortField: "valueCurrent",
    },
    {
      id: "lastused",
      name: "Last Used",
      selector: (row) => row.lastUsed,
      sortable: true,
      sortField: "lastUsed",
      cell: (row, date) =>
        row.lastUsed !== "" ? (
          date = dateFormat(row.lastUsed, 'll'),
          <div className="relative">
              <span className="font-zero setFastpass">{date}</span>
              <span>{dateFormatAndStatus(row.lastUsed, "MM/DD/YY",custBootstrapDataRedux.user?.timeZone)[0]}{" "}</span>
            
          </div>
        ) : ("")

    },
    {
      id: "action",
      name: "Action",

      sortable: false,
      cell: (row) => <ActionComponent showActive={false} po={row} />,
    },
  ];

  const fetchActivePOList = () => {
    getAxiosResponse(APIUrls.PO_ENABLED_LIST)
      .then((response) => {
        if (response?.data?.code === 200) {
          setActivePOList(response?.data?.data?.result);
          setTotalActiveRows(response?.data?.data?.resultCount);
          setPending(false);

        $(".active-purchase-order .rdt_Table").attr("aria-label","Active Purchase Orders");
          setTimeout(() => {
             $(".active-purchase-order .rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
            $(".active-purchase-order .rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
          }, 300);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const InActiveListColumns = [
    {
      id: "ponumberin",
      name: "PO Number",
      selector: (row) => row.poNumber,
      sortable: true,
      sortField: "poNumber",
      cell: (row) => (
        <a tabIndex="0" onClick={() => {}}>
          {row.poNumber}
        </a>
      ),
    },
    {
      id: "namein",
      name: "Name",
      selector: (row) => row.poName,
      sortable: true,
      sortField: "poName",
    },
    {
      id: "currencyin",
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      sortField: "currency",
    },
    {
      id: "povaluein",
      name: "PO Value",
      selector: (row) => row.valueTotal?.display,
      sortable: true,
      sortField: "valueTotal",
    },
    {
      id: "spentvaluein",
      name: "Spent in Closed Projects",
      minWidth: "250px",
      selector: (row) => row.spentClosed?.display,
      sortable: true,
      sortField: "spentClosed",
    },
    {
      id: "balancein",
      name: "Balance",
      selector: (row) => row.valueCurrent?.display,
      sortable: true,
      sortField: "valueCurrent",
    },
    {
      id: "lastusedin",
      name: "Last Used",
      selector: (row) => row.lastUsed,
      sortable: true,
      sortField: "lastUsed",
      cell: (row, date) =>
        row.lastUsed !== "" ? (
          date = dateFormat(row.lastUsed, 'll'),
          <div className="relative">
              <span className="font-zero setFastpass">{date}</span>
              <span>{dateFormatAndStatus(row.lastUsed, "MM/DD/YY",custBootstrapDataRedux.user?.timeZone)[0]}{" "}</span>
            
          </div>
        ) : ("")

    },
    {
      id: "actionin",
      name: "Action",
      sortable: false,
      cell: (row) => <ActionComponent showActive={true} po={row} />,
    },
  ];

  const fetchInactivePOList = () => {
    getAxiosResponse(APIUrls.PO_DISABLED_LIST)
      .then((response) => {
        if (response?.data?.code === 200) {
          setInActivePOList(response?.data?.data?.result);
          setTotalInActiveRows(response?.data?.data?.resultCount);

        $(".inactive-purchase-order .rdt_Table").attr("aria-label","Inactive Purchase Orders");
          setTimeout(() => {
           $(".inactive-purchase-order .rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
           $(".inactive-purchase-order .rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1");
        }, 300);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const editPO = async (e) => {
    let dataObject = {
      editPoName:editPoName,
      editPoValue:editPoValue
    };
    const result = await editPOSchema.validate(dataObject,{abortEarly:false})
    .catch((err)=>{
      return err;
    });
    if(!result.errors){
      let data = {
        id: purchaseOrder.id,
        poNumber: editPoNumber,
        poName: editPoName,
        poDesc: editPoDesc,
        valueTotal: {
          value: editPoValue,
        },
        enabled: purchaseOrder.enabled,
        valueCurrent: {
          value: purchaseOrder.valueCurrent.value,
        },
        spentClosed: {
          value: purchaseOrder.spentClosed.value,
        },
        spentTranslation: {
          value: purchaseOrder.spentTranslation.value,
        },
        currency: purchaseOrder.currency,
      };
      putAxiosResponse(APIUrls.PO_UPDATE(data.id), data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setRefresh(refresh ? false : true);
          hideEditModal();
          setSuccessMessage("Purchase Order Edited Successfuly.");
        }
      }).catch((err) => {
        console.error(err);
      });
    }else {
      let dataErrors = {};
      result.inner.forEach((element) => {
        dataErrors[element.path] = element.message;
      });
      setErrors2(dataErrors);
    }
  };

  const handleEnableDisable = (value, key) => {
    let oldvalue = purchaseOrder[key];
    let keys = key.split(".");
    if (keys.length > 1) {
      oldvalue = purchaseOrder[keys[0]][keys[1]];
    }
    if (value != oldvalue) {
      const editButton = $("#edit-save");
      if (editButton.hasClass("disabled-btn")) {
        editButton.removeClass("disabled-btn");
      }
    } else {
      makeEditDisable();
    }
  };

  const showEditModal = (e, po) => {
    editRef.current = e.currentTarget.id;
    reset();
    setPurchaseOrder(po);
    setEditname(po.poName);
    setEditPoNumber(po.poNumber);
    setEditPoValue(po.valueTotal.value);
    setEditPoDesc(po.poDesc);
    setEditPoCurrency(po.currency);
    setEdit(true);
    makeEditDisable();
    setErrors2({});
    document.body.classList.add("modal-open");
    setTimeout(function () {
      $("#edit-cancel").trigger("focus");
    }, 300);
  };

  const hideEditModal = () => {
    setEdit(false);
    document.body.classList.remove("modal-open");
    reset();
  };

  const traceFocus = (event) => {
    if (document.activeElement.id === "edit-save" &&
    event.key === Constants.TAB &&
    event.shiftKey === false) {
      event.preventDefault();
      $("#editPOName").trigger("focus");
    } else if (
      document.activeElement.id === "editPOName" &&
      event.shiftKey && event.key == Constants.TAB
    ) {
    event.preventDefault();
    $("#edit-save").trigger("focus");
    } else if (
      event.key == Constants.ESCAPE
    ) {
    handleCancel(event);
    } else if (event.key === Constants.ENTER && (document.activeElement.id !== "edit-save" && document.activeElement.id !== "edit-cancel")) {
      event.preventDefault();
      return false;
    }
  };

  const handleCancel = (event) => {
    setTimeout(function () {
      $("#" + editRef.current).trigger("focus");
    }, 300);
    event.preventDefault();
    hideEditModal();
    reset();
  };

  const makeEditDisable = () => {
    const editButton = $("#edit-save");
    if (!editButton.hasClass("disabled-btn")) {
      editButton.addClass("disabled-btn");
    }
  };

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
      <div role="row" className="no-data-display align-center">
        <div role="cell">
          <i className="nodata-icon"></i>
          <p>{Constants.NO_RECORD_FOUND}</p>
        </div>
      </div>
    </div>
    );
  };

  const ActionComponent = (prop) => {
    const showActive = prop.showActive;
    const po = prop.po;
    return (
      <>
        <div className="flex-center">
          <button className="mr-15 inline-flex" aria-label="edit"
            onClick={(e) => showEditModal(e, po)} id={"edit-" + po.id}>
            {EditIcon}
          </button>
          {showActive ? (
            <ActiveClip deactivate={activateDeactivatePO} po={po} />
          ) : (
            <DeActiveClip activate={activateDeactivatePO} po={po} />
          )}
        </div>
      </>
    );
  };

  const ActiveClip = (prop) => {
    const po = prop.po;
    return (
      <>
        <button className="inline-flex" aria-label="Active" title="Activate" onClick={() => prop.deactivate(po, true)} >
          {ActivatedClip}
        </button>
      </>
    );
  };

  const DeActiveClip = (prop) => {
    const po = prop.po;
    return (
      <>
        <button className="inline-flex" aria-label="Deactivate" title="Deactivate" onClick={() => prop.activate(po, false)} >
          {DeActivateClip}
        </button>
      </>
    );
  };

  const validationsForAddPO = {
    poNumber: {
      required: "Order Number is required",
      maxLength: {
        value: 15,
        message: "Please Enter a Valid Order Number"
      },
      validate: (value) => {
        let regex = new RegExp(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/);
        return !regex.test(value);
      },
    },
    poName: {
      required: "Order Name is required",
      maxLength: {
        value: 40,
        message: "Please Enter a Valid Order Name"
      },
      validate: (value) => {
        let regex = new RegExp(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/);
        return !regex.test(value);
      },
    },
    poDesc: {
      maxLength: {
        value: 250,
        message: "Description must be 250 characters long"
      },
      validate: (value) => {
        let regex = new RegExp(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/);
        return !regex.test(value);
      },
    },
    valueTotal: {
      required: "Total value is required",
      min:{
        value:1,
        message:"Total value must be greater than 0"
      },
      maxLength: {
        value: 8,
        message: "Total value must be 8 digit long"
      },
    },
    selectedCurrency: {
      required: "Currency is required"
    },
  };

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Purchase orders', url:''},
  ];

  return (
    <>
      <div className="body bg-color">
        <div id="container" className="dashboard-wrapper">
          <Header ref={scrollRef} />
          <LeftNavbar />
          <section className="dashboard-content" ref={scrollRef}>
            <div id="content" className="dashboard-wrap">
              <Breadcrumb crumbs={ crumbs } />
              <div className="system-setting-page">
                <div className="project-heading userprofile-heading">
                  <div className="back-arrow flex-center" onClick={() => navigate("/settings")} >
                    <button aria-label="back">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none" >
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#1D4ED8" />
                      </svg>
                    </button>
                    <span>Back to Settings</span>
                  </div>
                  <h3>Purchase Orders Management</h3>
                  <span>Manage, browse, and edit your purchase orders.</span>
                </div>
                <div className="white-bg">
                  <div className="purchase-orders-page">
                    {mandatory == null ? (
                      Constants.BLANK
                    ) : (
                      <div className="purchase-yesno-list mar-bot40" role="radiogroup" aria-labelledby="group_label_1">
                        <h5 className="heading-width-border" id="group_label_1">
                          Make purchase order number mandatory for projects?
                        </h5>
                        <div className="radio-form-check">
                          <input type="radio" className="form-check-input" name="radio" id="no"
                            checked={!isForced} onChange={() => toggleCheckBox(false)} />
                          <label className="form-check-label" htmlFor="no">
                            No, users can select a quote without a purchase
                            order number.
                          </label>
                        </div>
                        <div className="radio-form-check">
                          <input type="radio" className="form-check-input" title="Yes, users must enter a purchase order number to select a quote."
                            checked={isForced} name="radio" id="yes"
                            onChange={() => toggleCheckBox(true)} />
                          <label className="form-check-label" htmlFor="yes">
                            Yes, users must enter a purchase order number to
                            select a quote.
                          </label>
                        </div>
                        <button id="yes-no-save" className="blue-btn active mar-top15 disabled-data"
                          aria-label="Save" onClick={makeMandatory} >
                          Save
                        </button>
                      </div>
                    )}
                    <form id="add-from" onSubmit={handleSubmit(addPO)}>
                      <div className="add-new-purchase-order  mar-bot40">
                        <h5 className="heading-width-border">
                          Add new Purchase Order
                        </h5>
                        <div className="flex wrap-dropdown mb-0">
                          <div className="global-dropdown-block mar-bot20">
                            <label htmlFor="orderNumber">Order Number</label>
                            <input id="orderNumber" type="text" className="form-control-sm" aria-describedby="errorOrderNumber" aria-required='true'
                              {...register(
                                "poNumber",
                                validationsForAddPO.poNumber
                              )}
                              value={poNumber} onChange={(e) => setPoNumber(e.target.value)}
                            />
                            <div className="error" id="errorOrderNumber" >
                              {errors.poNumber &&
                              errors.poNumber?.type === "validate"
                                ? "Please Enter a Valid Order Number"
                                : errors.poNumber?.message}
                            </div>
                          </div>
                          <div className="global-dropdown-block mar-bot20">
                            <label htmlFor="orderName">Order Name</label>
                            <input id="orderName" type="text" className="form-control-sm" aria-describedby="errorOrderName" aria-required='true'
                              {...register(
                                "poName",
                                validationsForAddPO.poName
                              )}
                              value={poName} onChange={(e) => setPOName(e.target.value)}
                            />
                            <div className="error" id="errorOrderName" >
                              {errors.poName &&
                              errors.poName?.type === "validate"
                                ? "Please Enter a Valid Order Name"
                                : errors.poName?.message}
                            </div>
                          </div>
                        </div>
                        <div className="flex wrap-dropdown mb-0">
                          <div className="global-dropdown-block mar-bot20">
                            <label htmlFor="description">Description (Optional)</label>
                            <input id="description" type="text" className="form-control-sm" aria-describedby="errorDesc"
                              {...register(
                                "poDesc",
                                validationsForAddPO.poDesc
                              )}
                              value={poDesc} onChange={(e) => { setPODesc(e.target.value); }}
                            />
                            <div className="error" id="errorDesc" >
                              {errors.poDesc &&
                              errors.poDesc?.type === "validate"
                                ? "Please Enter Valid Description"
                                : errors.poDesc?.message}
                            </div>
                          </div>
                          <div className="global-dropdown-block sign-dollar-block mar-bot20">
                            <label htmlFor="totalValue">Total Value</label>
                            <input id="totalValue" type="number" className="form-control-sm" aria-describedby="errorTotalValue" aria-required='true'
                              {...register(
                                "valueTotal",
                                validationsForAddPO.valueTotal
                              )}
                              value={valueTotal} onChange={(e) => setValueTotal(Math.max(0, e.target.value))}
                            />
                            <div className="sign-dollar">{currencySymbol}</div>
                            <div className="error" id="errorTotalValue" >
                              {errors.valueTotal?.message}
                            </div>
                          </div>
                        </div>
                        {currencies?.length ? (
                          <div className="flex wrap-dropdown mb-0">
                            <div className="global-dropdown-block mar-bot20">
                              <label>Choose Currency</label>
                              <Select className="global-dropdown-select isselectRemove" classNamePrefix="cw"
                                value={currencies.find(
                                  (option) => option.code === selectedCurrency
                                )}
                                options={currencies}
                                defaultValue={currencies[0]}
                                onChange={(e) => handleCurrencyChange(e)}
                                aria-label="Choose Currency"
                              />
                            </div>
                          </div>
                        ) : (
                          Constants.BLANK
                        )}
                        <button id="add-button" type="submit" className="blue-btn active disabled-data" aria-label="Add" >
                          Add
                        </button>
                      </div>
                    </form>
                    <div className="active-purchase-order mar-bot40">
                      <h5 className="heading-width-border mar-bot20">
                        Active Purchase Orders
                      </h5>
                      <div className="datatable-block">
                        <DataTable
                          keyField="id"
                          columns={activeListColumns}
                          data={activePOList}
                          responsive
                          striped
                          sortServer
                          onSort={customSort}
                          pagination
                          onChangeRowsPerPage={handleChange}
                          paginationServer
                          paginationTotalRows={totalActiveRows}
                          paginationRowsPerPageOptions={[
                            10, 20, 40, 50, 100, 200,
                          ]}
                          onChangePage={handlePageChange}
                          progressPending={pending}
                          noDataComponent={noDataFoundComponent()}
                        />
                      </div>
                    </div>
                    <div className="inactive-purchase-order mar-bot40">
                      <h5 className="heading-width-border mar-bot20">
                        Inactive Purchase Orders
                      </h5>
                      <div className="datatable-block">
                        <DataTable
                          keyField="id"
                          columns={InActiveListColumns}
                          data={inActivePOList}
                          responsive
                          striped
                          sortServer
                          onSort={customSortInActive}
                          pagination
                          onChangeRowsPerPage={handleChangeInactive}
                          paginationServer
                          paginationTotalRows={totalInActiveRows}
                          paginationRowsPerPageOptions={[
                            10, 20, 40, 50, 100, 200,
                          ]}
                          onChangePage={handlePageChangeInActive}
                          progressPending={pendingInactive}
                          noDataComponent={noDataFoundComponent()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {isEdit && <div className="lightbox-panel" aria-labelledby="editPurchaseOrderLabel" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel purchase-order-popup pb-0" onKeyDown={(e) => traceFocus(e)} >
            <div className="modal-header flex padd-lr">
              <h5 id="editPurchaseOrderLabel">Edit Purchase Order</h5>
            </div>
              <div className="lightbox-content padd-22">
                <div className="table-responsive global-table">
                  <table className="sortable" aria-label="Edit Purchase Order">
                    <thead>
                      <tr>
                        <th scope="col" aria-label="P O Number">PO Number</th>
                        <th scope="col">Name</th>
                        <th scope="col" className="left-text" aria-label="P O Value">PO Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{editPoNumber}</td>
                        <td>
                          <div className="global-dropdown-block mb-0">
                            <input id="editPOName" type="text" className="form-control-sm" title="Name" aria-describedby="errorEditPOName" aria-required='true'
                              value={editPoName}
                              onChange={(e) => {
                                setEditname(e.target.value);
                                handleEnableDisable(e.target.value, "poName");
                              }}
                            />
                            {errors2?.editPoName && 
                            <p className="error" id="errorEditPOName">
                              {errors2?.editPoName}
                            </p>
                            }
                          </div>
                        </td>
                        <td>
                          <div className="global-dropdown-block sign-dollar-block mb-0">
                            <input type="number" className="form-control-sm" title="P O Value" aria-describedby="errorEditNumber" aria-required='true'
                              value={editPoValue}
                              onChange={(e) => {
                                setEditPoValue(Math.max(0, e.target.value));
                                handleEnableDisable(
                                  e.target.value,
                                  "valueTotal.value"
                                );
                              }}
                            />
                            <div className="sign-dollar" aria-label={editPoCurrency}>
                              {currencies && currencies?.length > 0 &&  currencies?.filter(data=>data?.code===editPoCurrency)[0]?.symbol}
                            </div>
                            {errors2?.editPoValue && 
                            <p className="error" id="errorEditNumber">
                              {errors2?.editPoValue}
                            </p>
                            }
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="3">
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="global-dropdown-block mar-bot6 left-text w-d100">
                  <label for="DescriptionNotes" className="mar-bot6 show-flex justify-center" aria-label="Description Notes optional">
                    Description / Notes: <span>Optional</span>
                  </label>
                  <input id="DescriptionNotes" type="text" className="form-control-sm" aria-describedby="errorEditDesc"
                    value={editPoDesc}
                    onChange={(e) => {
                      setEditPoDesc(e.target.value);
                      handleEnableDisable(e.target.value, "poDesc");
                    }}
                  />
                </div>
              </div>
              <div className="modal-footer modal-footer-border flex px-22">
                <button id="edit-cancel" className="btn btn-bold"  aria-label="Cancel" onClick={handleCancel} >
                  Cancel
                </button>
                <button id="edit-save" type="submit" 
                  className="btn btn-bold active disabled-btn" aria-label="Save"
                  onClick={(e) => editPO(e)} >
                  Save
                </button>
              </div>
          </div>
        </div>}
      </div>
      {successMessage !== undefined && successMessage !== Constants.BLANK ? (
        <SuccessMessage message={successMessage} />
      ) : (
        Constants.BLANK
      )}
    </>
  );
}
